import React from 'react';
import { WarningOutlined } from '@ant-design/icons';
import { getActiveAlarmLabels } from './amplifierAlarmLabels';
import { useAmplifierI18n } from '../../i18n/amplifier/useAmplifierI18n';

interface AmplifierAlarmBannerProps {
    alarmWord: number;
    onViewDetails: () => void;
}

const AmplifierAlarmBanner: React.FC<AmplifierAlarmBannerProps> = ({
    alarmWord,
    onViewDetails,
}) => {
    const { t } = useAmplifierI18n();
    const activeLabels = getActiveAlarmLabels(alarmWord, t);

    if (activeLabels.length === 0) {
        return null;
    }

    return (
        <div className="amplifier-alarm-overlay" aria-live="polite">
            <div className="amplifier-alarm-overlay__stack">
                {activeLabels.map((label) => (
                    <div
                        key={label}
                        className="amplifier-alarm-card"
                        role="alert"
                        onClick={onViewDetails}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                onViewDetails();
                            }
                        }}
                        tabIndex={0}
                    >
                        <WarningOutlined className="amplifier-alarm-card__icon" />
                        <span className="amplifier-alarm-card__text">{label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AmplifierAlarmBanner;
